import URI from 'urijs';
import config from '@/config';
import promisify from '@/utils/promisify';

const pptvAppId = 'wx8c9cfc1f578d8f20'; // 没有snsapi_userinfo权限
const pptvAppType = 'wx';
const ppsportAppId = 'wx1558ba248a365287';
const ppsportAppType = 'ttdzs';
const smartStoreAppId = 'wx1c544535105c441b';
const smartStoreAppType = 'snzhmd';
const pptvGameAppId = 'wx6f4c84363c67e276';
const pptvGameAppType = 'pgame_wx';

// 目前只有 ppsportAppType 公众号可以授权成功，pptvAppType会授权失败，需要联系王涛涛（18048474）配置对应的appType
// 目前只有 ppsportAppType 公众号可以授权成功，pptvAppType会授权失败，需要联系王涛涛（18048474）配置对应的appType
// 目前只有 ppsportAppType 公众号可以授权成功，pptvAppType会授权失败，需要联系王涛涛（18048474）配置对应的appType
export function jumpToGetOpenid({ wxType = 'wx' } = {}) {
  // 如果都没有，则通过公众号重定向授权，获取相关信息
  // todo: 根据appType决定用哪个公众号
  const appType = wxType;
  let appid = pptvAppId;
  switch (`${wxType}`) {
    case pptvAppType:
      appid = pptvAppId;
      break;
    case ppsportAppType:
      appid = ppsportAppId;
      break;
    case smartStoreAppType:
      appid = smartStoreAppId;
      break;
    case pptvGameAppType:
      appid = pptvGameAppId;
      break;
    default:
      break;
  }
  const ppuri = new URI(`${window.location.protocol}${config.HOST.pppassport}/wechat/sports/web/login`);
  ppuri.setQuery({
    appType,
    redirectURL: window.location.href,
  });
  const wxuri = new URI(`${config.HOST.wechat}/connect/oauth2/authorize`);
  wxuri.setQuery({
    appid,
    redirect_uri: ppuri.toString(),
    response_type: 'code',
    scope: appType === pptvAppType ? 'snsapi_login' : 'snsapi_userinfo',
    state: 1,
    connect_redirect: 1,
  });
  wxuri.fragment('wechat_redirect');
  window.location.replace(wxuri.toString());
}

export async function remoteWxUserInfo(accessToken, openid) {
  const [wxUserInfo] = await promisify(window.$.ajax.bind($.ajax), {
    url: `${config.sit.HOST.mppsport}/wx/utils/sns/userinfo.htm`,
    data: {
      accessToken,
      openid,
    },
    dataType: 'jsonp',
    jsonp: 'callback',
    jsonpCallback: 'wxUserInfo',
  });
  if (wxUserInfo.errcode) {
    throw new Error(wxUserInfo);
  }
  return wxUserInfo;
}

export function getOpenid(option) {
  const uri = new URI(window.location);
  let query = uri.query(true);
  let hastOpenid = !!query.openid;
  // pptv passport 对hash部分处理有问题，可能会把openid等参数拼在hash后面。所以这里需要特殊处理
  if (!hastOpenid) {
    let hashStr = window.location.hash.slice(1);
    if (!hashStr.includes('?')) {
      hashStr = `?${hashStr}`;
    }
    if (hashStr) {
      const hashUri = new URI(hashStr);
      const hashQuery = hashUri.query(true);
      if (hashQuery.openid) {
        query = hashQuery;
        hastOpenid = true;
      }
    }
  }
  if (query.openid) {
    return query;
  } else {
    jumpToGetOpenid(option);
  }
}

export async function getWxUserInfo(option) {
  const { openid, wx_access_token: wxAccessToken } = getOpenid(option);
  const userInfo = await remoteWxUserInfo(wxAccessToken, openid);
  return userInfo;
}
